import { render, staticRenderFns } from "./PropertyOverview2.vue?vue&type=template&id=67e12653&"
import script from "./PropertyOverview2.vue?vue&type=script&lang=js&"
export * from "./PropertyOverview2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports